<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <ul class="block-sliders-manage-item">
              <li v-for="(item, index) in sliders" v-bind:key="index">
                <div class="banner-manage-news-picture"><img :src="item.picPath"></div>
                <div class="banner-manage-title">新闻标题：{{item.title}}</div>
                <div class="banner-manage-link">链接地址：{{item.link}}</div>
                <Row class="banner-manage-opt" style="width: 320px;">
                  <Col span="18"><Input search enter-button="设置权重" v-model="weights[index]" @on-search="setWeight(item, index)" placeholder="输入权重..." /></Col>
                  <Col span="6" style="text-align: right;"><Button type="error" @click="sliderDelete(item)">删除</Button></Col>
                </Row>
              </li>
            </ul>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader
  },

  //数据
  data() {
    return {
      token: '',
      page: 1,
      sliders: [],
      num: 0,
      weights: [],
    }
  },

  //页面加载完成
  mounted: function() {
    //初始化用户信息
    this.initAuthData()

    //获取banner
    this.getBannerList()
  },

  //自定义页面方法
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
      }
    },

    //列表数据获取
    getBannerList () {
      let vm = this
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/blocks/list-for-index-sliders",
        {blockId: 2, status: 1, page: vm.page},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let errorCode = res.data.code
        if(!isNaN(errorCode) && errorCode==0) {
          let data = res.data.data
          vm.sliders = data.sliders
          vm.num = data.num
          vm.sliders.forEach(function(v, k) {
          vm.weights[k] = vm.sliders[k].showOrder
          });
        }
      }).catch(function(error) {
        console.log(error)
      });
    },

    //设置权重
    setWeight(item, index) {
      let vm = this
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/blocks/save-weight-for-index-slider",
        {sliderId: item.sliderId, weight: this.weights[index]},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let errorCode = res.data.code
        if(!isNaN(errorCode) && errorCode==0) {
          let data = res.data
          let errorCode = parseInt(data.code)
          if(!isNaN(errorCode) && errorCode==0) {
            vm.getBannerList();
          }
        }
      }).catch(function(error) {
        console.log(error)
      });
    },

    //删除区块图片
    sliderDelete(item) {
      let vm = this
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/blocks/delete-index-slider",
        {sliderId: item.sliderId, status: -1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let errorCode = res.data.code
        if(!isNaN(errorCode) && errorCode==0) {
          let data = res.data
          let errorCode = parseInt(data.code)
          if(!isNaN(errorCode) && errorCode==0) {
            vm.getBannerList();
          }
        }
      }).catch(function(error) {
        console.log(error)
      });
    }

  }
}
</script>